import React from 'react';

export default function NotFound() {
  return (
    <>
      <h1 className='mt-3'>Page Not Found</h1>
      <img src='https://webartdevelopers.com/blog/wp-content/uploads/2018/10/HTML-404-Page.gif' alt='page not found'></img>
    </>
  );
}
